import { CurrencyPipe } from '@angular/common';
import {
  Component,
  effect,
  inject,
  model,
  OnInit,
  signal,
  viewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { IPaginar } from '@core/interfaces/paginacion/paginacion.interface';
import { ITablaColumna } from '@core/interfaces/tabla.interface';
import { CreditoApiService } from '@core/services/api/credito-api.service';
import { InputBuscador } from '@shared/components/input-buscador/input-buscador';
import { Paginacion } from '@shared/components/paginacion/paginacion';
import { Tabla } from '@shared/components/tabla/tabla';
import { UiButton, UiTooltip } from '@shared/components/ui';
import { TelefonoPipe } from '../../shared/pipes/telefono.pipe';
import { IResumenGeneralCreditoRes } from '@core/interfaces/request-response/credito.dto.interface';
import { Router } from '@angular/router';
import { IClienteCreditoListadoRes } from '@core/interfaces/request-response/credito.dto.interface';
import { AppService } from '@shared/services/app.service';
import { SucursalService } from '@shared/services/sucursal.service';

@Component({
  selector: 'app-credito',
  imports: [InputBuscador, UiButton, Tabla, Paginacion, CurrencyPipe, TelefonoPipe, UiTooltip],
  templateUrl: './credito.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './credito.css',
})
export class Credito implements OnInit {
  constructor() {
    effect(() => {
      if (this.sucursalService.sucursalReady() && this.appService.authReady()) {
        this.creditoApiService.datosGenerales().subscribe((res) => {
          this.resumenGeneral.set(res);
        });
        this.cambiarPagina(1);
      }
    });
  }

  private itemsPorPagina = 18;

  ngOnInit(): void {
    this.appService.setPanelHeader({
      title: 'Clientes con créditos',
      subtitle: 'Aquí puedes gestionar los créditos de los clientes',
      showBackButton: true,
      icon: 'bi bi-person',
    });
    this.columnasTabla = [
      { key: 'nombre_completo', titulo: 'Cliente' },
      { key: 'dniRuc', titulo: 'DNI / RUC' },
      { key: 'numero_celular', titulo: 'Número Celular', template: this.telefonoTemplate() },
      { key: 'totalCredito', titulo: 'Total Crédito', template: this.deudaTemplate() },
      { key: 'ventasPendientes', titulo: 'Ventas Pendientes' },
    ];
  }
  // servicios
  private creditoApiService = inject(CreditoApiService);
  private router = inject(Router);
  private appService = inject(AppService);
  private sucursalService = inject(SucursalService);
  // datos
  telefonoTemplate = viewChild('telefonoTemplate');
  deudaTemplate = viewChild('deudaTemplate');
  busqueda = model('');
  columnasTabla: ITablaColumna[] = [];

  resumenGeneral = signal<IResumenGeneralCreditoRes | null>(null);
  paginacion = signal<IPaginar<IClienteCreditoListadoRes> | null>(null);

  // métodos
  onBuscar() {}
  cambiarPagina(page: number) {
    this.creditoApiService.paginar(page, this.itemsPorPagina).subscribe((res) => {
      this.paginacion.set(res);
    });
  }

  verCreditos(data: IClienteCreditoListadoRes) {
    this.router.navigate(['/panel/gestion/creditos/ver', data.id]);
  }
}
